var _defs, _g, _g2, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _circle4, _path7, _path8, _path9, _path10, _circle5, _circle6, _circle7, _path11, _path12, _path13, _g3, _circle8, _circle9, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #878585;\n      }\n\n      .st1 {\n        fill: #a10a46;\n      }\n\n      .st2 {\n        fill: #126398;\n      }\n\n      .st3 {\n        fill: #9ca507;\n      }\n\n      .st4 {\n        fill: #fff;\n        stroke: #bfcc01;\n        stroke-miterlimit: 10;\n        stroke-width: 8px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,74.5c0,.4-.1.6-.2.8-.1.2-.4.5-.6.6s-.5.4-1,.4h-3.2v2.6h-1v-6.7h4.4c.4,0,.6.2.8.4s.5.4.6.6c0,.5.1.8.1,1.1v.2ZM10.4,74.6c0-.5-.1-.7-.5-1-.4-.2-.7-.4-1.3-.4h-2.2v2.6h2c1.3,0,1.9-.5,1.9-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.9,79.2l-.7-1.7h-3.5l-.7,1.7h-1l2.9-6.7h1.1l2.9,6.7h-1ZM16,74.6s-.1-.2-.1-.4-.1-.2-.1-.4-.1-.2-.1-.4-.1-.2-.1-.2c0,0,0,0-.1.2-.1.1-.1.2-.1.4s-.1.2-.1.4-.1.2-.1.4l-1,2.2h2.9s-1-2.2-1-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9,75.8c0,.6-.1,1.1-.4,1.6-.2.5-.5.8-.8,1.1-.4.2-.7.5-1.3.6-.5,0-1,.2-1.6.2h-2v-6.7h2.2c.6,0,1.1,0,1.6.2.5,0,.8.4,1.2.6s.6.6.8,1.1c.4.2.4.7.4,1.3ZM26,75.9c0-.8-.2-1.6-.7-2-.5-.5-1.2-.7-2.2-.7h-1.2v5.4h2.4c.4,0,.7-.2,1-.5.2-.2.5-.5.6-.8,0-.4.1-.8.1-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,79.2v-6.7h5v.7h-4.1v2.2h2.4v.7h-2.4v2.5h4.3v.7h-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.4,79.2v-6.7h1v6h4.1v.7h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,79.2v-6.7h1v6.7h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.7,79.2l-3.7-4.5v-.7c0-.2,0,0,0,0v5.5h-1v-6.7h1l3.6,4.7v.7c0,.2,0,0,0,0v-5.5h1v6.7h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.1,75.8c0,.6,0,1.1-.4,1.6s-.5.8-.8,1.1c-.4.2-.7.5-1.3.6s-1,.2-1.6.2h-2v-6.7h2.3c.6,0,1.1,0,1.6.2.5,0,.8.4,1.2.6s.6.6.8,1.1c0,.2.2.7.2,1.3ZM64.2,75.9c0-.8-.2-1.6-.7-2-.5-.5-1.2-.7-2.2-.7h-1.2v5.4h2.4c.4,0,.7-.2,1-.5.2-.2.5-.5.6-.8v-1.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.8,75.9c0,.5,0,1-.2,1.4,0,.5-.4.8-.7,1.1-.4.4-.7.6-1.1.7-.5,0-1,.2-1.4.2s-1,0-1.4-.2-.8-.4-1.1-.7c-.4-.4-.5-.7-.7-1.1,0-.5-.2-.8-.2-1.4s0-1,.2-1.4c0-.5.4-.8.7-1.1.4-.4.7-.6,1.1-.7.5,0,1-.2,1.4-.2s1,0,1.4.2c.5,0,.8.4,1.1.7.4.4.5.7.7,1.1,0,.4.2.8.2,1.4ZM72.9,75.9c0-.5,0-.8-.2-1.2s-.4-.6-.5-.8c-.2-.2-.5-.5-.8-.6s-.6-.2-1-.2-.7,0-1,.2c-.4,0-.6.4-.8.6s-.4.5-.5.8c0,.4-.2.7-.2,1.2s0,.8.2,1.2c0,.4.4.6.5.8.2.2.5.5.8.6s.6.2,1,.2.7,0,1-.2c.4,0,.6-.4.8-.6s.4-.5.5-.8c0-.4.2-.8.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.4,75.9c0,.5,0,1-.2,1.4,0,.5-.4.8-.7,1.1-.4.4-.7.6-1.1.7-.5,0-1,.2-1.4.2s-1,0-1.4-.2c-.5,0-.8-.4-1.1-.7-.4-.4-.5-.7-.7-1.1-.1-.5-.1-1-.1-1.4s0-1,.2-1.4c0-.5.4-.8.7-1.1.4-.4.7-.6,1.1-.7.5,0,1-.2,1.4-.2s1,0,1.4.2c.5,0,.8.4,1.1.7.4.4.5.7.7,1.1.1.4.1.8.1,1.4ZM81.6,75.9c0-.5,0-.8-.2-1.2s-.4-.6-.5-.8-.5-.5-.8-.6-.6-.2-1-.2-.7,0-1,.2c-.4,0-.6.4-.8.6s-.4.5-.5.8c0,.4-.2.7-.2,1.2s0,.8.2,1.2.4.6.5.8c.2.2.5.5.8.6s.6.2,1,.2.7,0,1-.2c.4,0,.6-.4.8-.6s.4-.5.5-.8c0-.4.2-.8.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,74.3c0,.5,0,1-.5,1.3-.4.4-.8.5-1.4.6l1.8,2.9h-1.1l-1.8-2.7h-2v2.9h-1v-6.7h4.4c.4,0,.6.2.8.4s.4.4.6.6v.7h.1ZM89.6,74.5c0-.4,0-.7-.5-1-.2-.2-.7-.4-1.3-.4h-2.3v2.5h2.3c.6,0,1.1,0,1.3-.4.4,0,.5-.5.5-.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.1,69.1l-.7-2h-4.3l-.7,2h-3.1l4.2-12.1h3.6l4.2,12.1s-3.1,0-3.1,0ZM9.8,64.8h2.9l-1.4-4.3-1.4,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,64.3v4.7h-2.9v-12h4.8c1.4,0,2.5.4,3.2,1.1.7.7,1.2,1.6,1.2,2.6s-.2,1.3-.6,2c-.5.7-1.1,1.2-2,1.4l3,4.9h-3.5l-2.7-4.7h-.5ZM21.6,59.3v2.9h1.8c.5,0,.8,0,1.1-.4.2-.2.4-.6.4-1.1s-.1-.7-.4-1.1c-.2-.2-.6-.4-1.1-.4h-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.7,69.1l-.7-2h-4.3l-.7,2h-3l4.2-12.1h3.6l4.2,12.1s-3.2,0-3.2,0ZM33.4,64.8h2.9l-1.4-4.3-1.4,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4,69.1l-4.3-12.1h3.1l3,9.2,3-9.2h3.1l-4.3,12.1s-3.6,0-3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.4,69.1l-.7-2h-4.3l-.7,2h-3.1l4.2-12.1h3.6l4.2,12.1s-3.1,0-3.1,0ZM58.2,64.8h2.9l-1.4-4.3-1.4,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.9,57h2.9v9.8h3.7v2.3h-6.6s0-12.1,0-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.2,57h2.9v9.8h3.7v2.3h-6.6v-12.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,57v2.2h-4.3v2.6h3.8v2.3h-3.8v2.7h4.3v2.3h-7.3v-12.1s7.3,0,7.3,0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.9,52.5h-9.2c-.4,0-.6-.5-.2-.7l6.8-5.9h.6l2.5,5.9c0,.2-.2.6-.5.6h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68,33.8c1,0,1.7-.7,1.7-1.7s-.7-1.7-1.7-1.7-1.7.7-1.7,1.7.7,1.7,1.7,1.7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 62.6,
    cy: 33.7,
    r: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 57.2,
    cy: 35.2,
    r: 1.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 51.8,
    cy: 36.8,
    r: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48,43.5c-.5,0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.5,39.9c1,0,1.7-.7,1.7-1.7s-.7-1.7-1.7-1.7-1.7.7-1.7,1.7.8,1.7,1.7,1.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.9,38.7c1.1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9,1,1.9,1.9,1.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.6,39.9c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4,1.4.6,1.4,1.4,1.4,1.4-.7,1.4-1.4Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 58.8,
    cy: 41.3,
    r: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.4,41.8c-.6,0-1.1.5-1.1,1.1s.5,1.1,1.1,1.1,1.1-.5,1.1-1.1-.5-1.1-1.1-1.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.6,49.6c-.5,0-.8.4-.8.8s.4.8.8.8.8-.4.8-.8-.4-.8-.8-.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.2,42.8c-1,0-1.7.7-1.7,1.7s.7,1.7,1.7,1.7,1.7-.7,1.7-1.7c-.1-1-.8-1.7-1.7-1.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.4,43c0-1.1-.8-1.9-1.9-1.9s-1.9.8-1.9,1.9.8,1.9,1.9,1.9,1.9-1,1.9-1.9Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 65.8,
    cy: 46,
    r: 1.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 60.3,
    cy: 47.4,
    r: 1.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 55,
    cy: 49,
    r: 1.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.8,48.9c-1,0-1.7.7-1.7,1.7s.7,1.7,1.7,1.7,1.7-.7,1.7-1.7-.8-1.7-1.7-1.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.1,47.2c-1.1,0-1.9.8-1.9,1.9s.8,1.9,1.9,1.9,1.9-.8,1.9-1.9-.8-1.9-1.9-1.9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.4,50.7c-.8,0-1.4.6-1.4,1.4s.6,1.4,1.4,1.4,1.4-.6,1.4-1.4-.6-1.4-1.4-1.4Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,37c-1.2-3.3-2.4-5.5-2.7-6-.5.5-1,1-1.6,1.3.5.7,1.4,2.7,2.5,5.5,1.2,3.3,2.5,8.5,2.2,14.5v.2h2c.2-6.5-1.2-12.1-2.4-15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.5,17.8s-3.2-.8-7.8-.6c-2.6.1-5.4.6-7.9,1.3-3.1,1-6.1,2.4-8.8,4.4-4.3,3.1-7.1,6.1-10,9.4-3.6,3.9-7.3,8.1-14.3,12.4l-12.4,7.7h3.6l9.8-6c7.3-4.5,11.1-8.7,14.8-12.9,2.9-3.2,5.5-6.2,9.7-9.1,2.5-1.8,5.4-3.2,8.2-4.1,2.4-.7,4.8-1.2,7.3-1.3,3.3-.1,5.9.2,6.8.5.4-.7.7-1.2,1.1-1.8h0Z"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 78,
    cy: 23.8,
    r: 5.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: -53.2,
    cy: 27.1,
    r: 14
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-83,82.4c0-16.5,13.4-29.9,29.9-29.9s29.9,13.4,29.9,29.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.0b3dc83983c31c9b2ea3567f8d5a0504.svg";
export { ForwardRef as ReactComponent };